import React from 'react'
import ProductsSectionTitle from '../ProductsSectionTitle'
import { Element } from 'react-scroll'

const MEAKeyFeatures = () => {
  return (
    <>
      <Element
        name="MEAKeyFeatures"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <ProductsSectionTitle
                classes = "text-center"
                title = "Key Features & Benefits"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center">Why choose our Edge AI solutions for your business.</p>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/spark.svg`} alt="spark" />
                </div>
                <h5 className="mt-3 mb-3">Real-time Intelligence</h5>
                <p className="mb-0">Process data locally with minimal latency for immediate insights and action.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/shield.svg`} alt="shield" />
                </div>
                <h5 className="mt-3 mb-3">Data Privacy & Security</h5>
                <p className="mb-0">Keep sensitive data on-premise, reducing exposure and maintaining compliance.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/database.svg`} alt="database" />
                </div>
                <h5 className="mt-3 mb-3">Reduced Cloud Costs</h5>
                <p className="mb-0">Minimize data transfer and storage costs by processing at the edge.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/pulse.svg`} alt="pulse" />
                </div>
                <h5 className="mt-3 mb-3">Operational Reliability</h5>
                <p className="mb-0">Maintain functionality even during network outages or connectivity issues.</p>
              </div>  
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/server.svg`} alt="server" />
                </div>
                <h5 className="mt-3 mb-3">Scalable Architecture</h5>
                <p className="mb-0">Start small and expand your Edge AI capabilities as needed.</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 px-0 px-md-4">
              <div className="mea-key-features-card p-4 bg-white">
                <div className="icon-image-box">
                  <img src={`${process.env.PUBLIC_URL}/images/icons/chip.svg`} alt="chip" />
                </div>
                <h5 className="mt-3 mb-3">Energy Efficiency</h5>
                <p className="mb-0">Optimize power consumption with our purpose-built hardware solutions.</p>
              </div>  
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default MEAKeyFeatures;